$mol_chip $mol_view
	minimal_height 40
	attr *
		^
		title <= hint \
	sub /
		<= title
